module.exports = __webpack_public_path__ + "img/joseph.96b62ae8.png";